package pnemonic.balloon_pop.drawable

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val Giraffe: ImageVector
    get() {
        if (_Giraffe != null) {
            return _Giraffe!!
        }
        _Giraffe = ImageVector.Builder(
            name = "Giraffe",
            defaultWidth = 320.73.dp,
            defaultHeight = 459.25.dp,
            viewportWidth = 320.73f,
            viewportHeight = 459.25f
        ).apply {
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFCEE21),
                        0.27f to Color(0xFFFCE91E),
                        0.59f to Color(0xFFFDDB14),
                        0.93f to Color(0xFFFFC304),
                        1f to Color(0xFFFFBD00)
                    ),
                    start = Offset(35.88f, 426.31f),
                    end = Offset(56.97f, 358.64f)
                )
            ) {
                moveTo(65.97f, 320.25f)
                curveTo(42.48f, 316f, 33.54f, 365.93f, 25.69f, 388.78f)
                curveTo(17.85f, 411.62f, 11.96f, 443.44f, 32.56f, 448.34f)
                curveTo(53.15f, 453.23f, 64.11f, 408.19f, 69.82f, 385.52f)
                curveTo(76.8f, 357.78f, 88.52f, 324.32f, 65.97f, 320.25f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFCEE21),
                        0.27f to Color(0xFFFCE91E),
                        0.59f to Color(0xFFFDDB14),
                        0.93f to Color(0xFFFFC304),
                        1f to Color(0xFFFFBD00)
                    ),
                    start = Offset(165.73f, 428.1f),
                    end = Offset(134.97f, 360.42f)
                )
            ) {
                moveTo(124.45f, 317.54f)
                curveTo(109.88f, 322.3f, 114.59f, 348.99f, 124.45f, 379.63f)
                curveTo(132.9f, 405.89f, 137.56f, 451.89f, 159.69f, 445.79f)
                curveTo(181.82f, 439.68f, 171.17f, 384.72f, 159.69f, 355.2f)
                curveTo(148.22f, 325.68f, 140.02f, 312.45f, 124.45f, 317.54f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFCEE21),
                        0.27f to Color(0xFFFCE91E),
                        0.59f to Color(0xFFFDDB14),
                        0.93f to Color(0xFFFFC304),
                        1f to Color(0xFFFFBD00)
                    ),
                    start = Offset(266.04f, 11.1f),
                    end = Offset(270.86f, 29.11f)
                )
            ) {
                moveTo(287.77f, 25.88f)
                curveTo(287.77f, 25.88f, 296.6f, 3.57f, 272.3f, 0.29f)
                curveTo(248.01f, -2.99f, 244.83f, 22.18f, 249.58f, 32.23f)
                curveTo(254.33f, 42.28f, 274.82f, 43.37f, 274.82f, 43.37f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFCEE21),
                        0.27f to Color(0xFFFCE91E),
                        0.59f to Color(0xFFFDDB14),
                        0.93f to Color(0xFFFFC304),
                        1f to Color(0xFFFFBD00)
                    ),
                    start = Offset(98.67f, 303.19f),
                    end = Offset(99.55f, 332.19f)
                )
            ) {
                moveTo(41.64f, 314.72f)
                curveTo(38.32f, 332.96f, 62.74f, 335.81f, 92.62f, 335.81f)
                curveTo(122.5f, 335.81f, 156.78f, 334.05f, 156.78f, 313.84f)
                curveTo(156.78f, 293.62f, 111.07f, 296.26f, 94.38f, 296.26f)
                curveTo(77.68f, 296.26f, 45.16f, 295.38f, 41.64f, 314.72f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFCEE21),
                        0.27f to Color(0xFFFCE91E),
                        0.59f to Color(0xFFFDDB14),
                        0.93f to Color(0xFFFFC304),
                        1f to Color(0xFFFFBD00)
                    ),
                    start = Offset(195.6f, 169.84f),
                    end = Offset(233.88f, 195.89f)
                )
            ) {
                moveTo(276.6f, 36.07f)
                curveTo(256.04f, 27.03f, 248.43f, 66.89f, 235.27f, 104.77f)
                curveTo(222.47f, 141.62f, 206.47f, 174.61f, 182.74f, 212.87f)
                curveTo(158.55f, 251.86f, 117.4f, 310.12f, 144.8f, 324.54f)
                curveTo(172.2f, 338.95f, 186.56f, 275.74f, 215.79f, 230.15f)
                curveTo(250.84f, 175.49f, 279.77f, 99.43f, 284.14f, 76.77f)
                curveTo(287.87f, 57.38f, 292.44f, 43.04f, 276.6f, 36.07f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFCEE21),
                        0.27f to Color(0xFFFCE91E),
                        0.59f to Color(0xFFFDDB14),
                        0.93f to Color(0xFFFFC304),
                        1f to Color(0xFFFFBD00)
                    ),
                    start = Offset(9.48f, 302.58f),
                    end = Offset(55.03f, 302.58f)
                )
            ) {
                moveTo(47.59f, 322.63f)
                curveTo(57.29f, 315.62f, 60.1f, 296.26f, 39.88f, 282.2f)
                curveTo(19.67f, 268.13f, 2.09f, 297.14f, 12.64f, 310.32f)
                curveTo(23.18f, 323.51f, 34.21f, 332.29f, 47.59f, 322.63f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFCEE21),
                        0.27f to Color(0xFFFCE91E),
                        0.59f to Color(0xFFFDDB14),
                        0.93f to Color(0xFFFFC304),
                        1f to Color(0xFFFFBD00)
                    ),
                    start = Offset(301.51f, 27.09f),
                    end = Offset(295.89f, 61.41f)
                )
            ) {
                moveTo(278.8f, 32.27f)
                curveTo(267.03f, 52.27f, 309.34f, 72.86f, 318.8f, 55.79f)
                curveTo(329.79f, 35.95f, 290.79f, 11.87f, 278.8f, 32.27f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFCEE21),
                        0.27f to Color(0xFFFCE91E),
                        0.59f to Color(0xFFFDDB14),
                        0.93f to Color(0xFFFFC304),
                        1f to Color(0xFFFFBD00)
                    ),
                    start = Offset(178.15f, 381.02f),
                    end = Offset(152.73f, 389.05f)
                )
            ) {
                moveTo(143.93f, 321.07f)
                curveTo(129.14f, 325.91f, 133.11f, 358.27f, 143.93f, 384.11f)
                curveTo(154.75f, 409.94f, 157.24f, 457.47f, 179.71f, 451.27f)
                curveTo(202.18f, 445.07f, 191.36f, 389.27f, 179.71f, 359.31f)
                curveTo(168.06f, 329.34f, 159.74f, 315.91f, 143.93f, 321.07f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.67f,
                strokeAlpha = 0.67f
            ) {
                moveTo(148.91f, 287.77f)
                curveTo(148.46f, 287.77f, 147.99f, 287.65f, 147.57f, 287.41f)
                curveTo(146.29f, 286.66f, 145.86f, 285.02f, 146.6f, 283.75f)
                curveTo(146.87f, 283.28f, 174f, 236.73f, 192.5f, 208.2f)
                curveTo(210.63f, 180.24f, 232.24f, 133.39f, 242.76f, 99.23f)
                curveTo(251.03f, 72.39f, 260.54f, 48.44f, 260.64f, 48.21f)
                curveTo(261.18f, 46.83f, 262.74f, 46.16f, 264.11f, 46.71f)
                curveTo(265.49f, 47.26f, 266.16f, 48.81f, 265.61f, 50.19f)
                curveTo(265.51f, 50.42f, 256.08f, 74.18f, 247.88f, 100.81f)
                curveTo(237.23f, 135.37f, 215.36f, 182.79f, 196.99f, 211.12f)
                curveTo(178.57f, 239.53f, 151.5f, 285.97f, 151.23f, 286.44f)
                curveTo(150.73f, 287.29f, 149.83f, 287.77f, 148.91f, 287.77f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(25.82f, 285.71f)
                curveTo(21.84f, 288.7f, 33.73f, 299.78f, 36.37f, 294.5f)
                curveTo(39f, 289.23f, 29.34f, 283.08f, 25.82f, 285.71f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFCEE21),
                        0.27f to Color(0xFFFCE91E),
                        0.59f to Color(0xFFFDDB14),
                        0.93f to Color(0xFFFFC304),
                        1f to Color(0xFFFFBD00)
                    ),
                    start = Offset(18.71f, 365.92f),
                    end = Offset(46.8f, 418.09f)
                )
            ) {
                moveTo(48.67f, 320.87f)
                curveTo(24.61f, 316.29f, 15.45f, 370.09f, 7.41f, 394.7f)
                curveTo(-0.62f, 419.31f, -6.65f, 453.58f, 14.44f, 458.86f)
                curveTo(35.54f, 464.13f, 44.58f, 414.91f, 52.62f, 391.18f)
                curveTo(60.65f, 367.45f, 71.78f, 325.26f, 48.67f, 320.87f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(24.06f, 374.48f)
                curveTo(18.39f, 372.86f, 39f, 326.14f, 44.28f, 327.02f)
                curveTo(49.55f, 327.9f, 30.22f, 376.24f, 24.06f, 374.48f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(63.61f, 305.93f)
                curveTo(60.2f, 311.05f, 120.74f, 307.69f, 119.86f, 303.29f)
                curveTo(118.99f, 298.9f, 65.37f, 303.29f, 63.61f, 305.93f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(150.63f, 327.02f)
                curveTo(146.46f, 328.41f, 165.57f, 373.6f, 169.96f, 370.97f)
                curveTo(174.36f, 368.33f, 158.54f, 324.38f, 150.63f, 327.02f)
                close()
            }
        }.build()

        return _Giraffe!!
    }

@Suppress("ObjectPropertyName")
private var _Giraffe: ImageVector? = null
